import * as z from "zod/v4";

export const updateTicketFlags = {
  name: "updateTicketFlags" as const,
  input: z.object({
    linearTicketId: z.string(),
    ticketFlags: z.array(z.enum(["flag", "updateCtx", "todo"])),
  }),
  output: z.object({ success: z.boolean(), updatedCount: z.number() }),
};
